<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Sucursal</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formSucursal" autocomplete="off">
            <!-- mat-form-field class="full-width">
                <mat-label>Rut </mat-label>
                <input matInput type="text" formControlName="rut" required />
                <mat-hint>Rut con formato 12345678-9</mat-hint>
                <mat-error *ngIf="rut.hasError('required')">
                    Debe ingresar el rut del cliente
                </mat-error>
                <mat-error *ngIf="rut.hasError('digitoVerificador')">
                    Debe ingresar un rut válido
                </mat-error>
            </mat-form-field -->

            <mat-form-field class="full-width">
                <mat-label>Nombre </mat-label>
                <input matInput type="text" formControlName="nombre" required />

                <mat-error *ngIf="nombre.hasError('required')">
                    Debe ingresar el nombre de la sucursal
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Direccion </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="direccion"
                    required
                />

                <mat-error *ngIf="direccion.hasError('required')">
                    Debe ingresar la direccion de la sucursal
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Región</mat-label>
                <mat-select
                    formControlName="idRegion"
                    (selectionChange)="buscarComunas($event)"
                    required
                >
                    <mat-option *ngFor="let r of regiones" [value]="r.id">
                        {{ r.nombre }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Comuna </mat-label>
                <mat-select formControlName="idComuna" required>
                    <mat-option *ngFor="let c of comunas" [value]="c.id">
                        {{ c.nombre }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="idComuna.hasError('required')">
                    Debe ingresar la comuna de la sucursal
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Telefono </mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="telefono"
                    required
                />

                <mat-error *ngIf="telefono.hasError('required')">
                    Debe ingresar el telefono de la sucursal
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formSucursal.value"
            [disabled]="!formSucursal.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
